// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__xgu3G","wrapper_img":"styles_wrapper_img__MQGan"};